const InfiniteScroll = require('infinite-scroll');
const NProgress = require('nprogress');

const Isotope = require('isotope-layout/dist/isotope.pkgd.min');
const imagesLoaded = require('imagesloaded');
// make imagesLoaded available for InfiniteScroll
InfiniteScroll.imagesLoaded = imagesLoaded;
import BScroll from '@better-scroll/core';
import ScrollBar from '@better-scroll/scroll-bar'
BScroll.use(ScrollBar)

window.AblCh = window.AblCh || {};

$(function () {
  AblCh.initializeTopicPageArticleListInfiniteScroll();
  AblCh.initializeArchivePageIssueListInfiniteScroll();
  AblCh.initializeIsotopeGrid();
  AblCh.initializeBetterScrollSlider();
  AblCh.initializeMenuTopicsScroller();
  AblCh.moveArticleMeta();
})

AblCh = $.extend(AblCh, {

  // isotope grid layout without infinite scroll (pages other than TopicPage)
  initializeIsotopeGrid: function () {
    let grids = document.querySelectorAll('.article__grid:not(.one-col)');
    if (grids) {
      grids.forEach(grid => {
        let isotopeGrid = new Isotope(grid, {
          itemSelector: '.magazine-article-list-item',
          percentPosition: true,
          masonry: {
            columnWidth: '.grid-sizer'
          }
        });
        document.addEventListener('lazyloaded', function (e) {
          isotopeGrid.layout();
        });
      })
    }
  },

  // TopicPage
  initializeTopicPageArticleListInfiniteScroll: function () {
    const articleList = document.querySelector('.article__list');
    if (articleList) {
      let articleListItemsIsotopeInstance = new Isotope(articleList, {
        itemSelector: '.article__list .magazine-article-list-item',
        percentPosition: true,
        masonry: {
          columnWidth: '.grid-sizer'
        }
      });

      // Re-layout isotope when an image was lazyloaded
      // Isotope cannot assume the size of the images before they are loaded because we don't provide "sizes"
      document.addEventListener('lazyloaded', function (e) {
        articleListItemsIsotopeInstance.layout();
      });


      if (document.querySelector('.pagination__next')) {

        let articleListInfiniteScroll = new InfiniteScroll(articleList, {
          path: '.pagination__next',
          // Select articles within the article list (not the hero item)
          append: '.article__list .magazine-article-list-item',
          hideNav: '.pagination',
          history: false,
          outlayer: articleListItemsIsotopeInstance
        });
        articleListInfiniteScroll.on('request', () => {
          NProgress.configure({showSpinner: false});
          NProgress.start();
        });
        articleListInfiniteScroll.on('append', () => {
          articleListItemsIsotopeInstance.layout();
          NProgress.done();
        });

      }
    }

  },

  // ArchivePage
  initializeArchivePageIssueListInfiniteScroll: function () {
    const archiveIssueList = document.querySelector('.archive__issueList');
    if (archiveIssueList) {
      if (document.querySelector('.pagination__next')) {

        let archiveIssueListInfiniteScroll = new InfiniteScroll(archiveIssueList, {
          path: '.pagination__next',
          // Select issues within the list of issues
          append: '.issue__archiveitem',
          hideNav: '.pagination',
          history: false,
          scrollThreshold: false,
          button: '.view-more-button',
          status: '.page-load-status'
        });
        archiveIssueListInfiniteScroll.on('request', () => {
          NProgress.configure({showSpinner: false});
          NProgress.start();
        });
        archiveIssueListInfiniteScroll.on('append', () => {
          NProgress.done();
        });
      }
    }

  },

  initializeBetterScrollSlider: function () {
    const articleSliderHolders = document.querySelectorAll('.article__scroller');
    articleSliderHolders.forEach(holder => {
      const articleSlider = new BScroll(holder, {
        scrollX: true,
        eventPassthrough: 'vertical',
        click: true,
        scrollbar: {
          fade: false,
          interactive: true,
          scrollbarTrackClickable: true,
        },
        // Allow links and arrows being clicked on touch
        preventDefaultException: {tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|AUDIO|A|I)$/}
      });

      // Scroll by clicking the arrows
      const arrowLeft = holder.parentNode.querySelector('.scroll.arrow__left');
      const arrowRight = holder.parentNode.querySelector('.scroll.arrow__right');
      arrowLeft.addEventListener('click', (e) => {
        articleSlider.scrollBy(600);
      });
      arrowRight.addEventListener('click', (e) => {
        articleSlider.scrollBy(-600);
      });

      // Show or hide the arrows based on the initial menu position
      this.showOrHideMenuTopicsArrowsBasedOnScrollPosition(articleSlider, arrowLeft, arrowRight);

      // Show or hide the arrows depending on the scrolling position
      articleSlider.on('scrollEnd', () => {
        this.showOrHideMenuTopicsArrowsBasedOnScrollPosition(articleSlider, arrowLeft, arrowRight);
      });
    });
  },

  initializeMenuTopicsScroller: function () {
    const menuTopicsHolder = document.querySelector('#menu-topics');
    if (menuTopicsHolder) {
      const menuTopics = new BScroll('#menu-topics', {
        scrollX: true,
        scrollY: false,
        click: true,
        scrollbar: {
          fade: false,
          interactive: true,
          scrollbarTrackClickable: true,
        },
        // Allow links and arrows being clicked on touch
        preventDefaultException: {tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|AUDIO|A|I)$/}
      })

      // Scroll to the active first level element
      let activeFirstLevelItem = document.querySelector('#menu-topics .active');
      if (activeFirstLevelItem) {
        menuTopics.scrollToElement(activeFirstLevelItem, 1000, true);
      }

      // if present, scroll to the active second level element
      let activeSecondLevelItem = document.querySelector('#menu-topics .sub.active');
      if (activeSecondLevelItem) {
        menuTopics.scrollToElement(activeSecondLevelItem, 1000, true);
      }

      // Scroll by clicking the arrows
      const arrowLeft = document.querySelector('.arrow__left');
      const arrowRight = document.querySelector('.arrow__right');
      arrowLeft.addEventListener('click', (e) => {
        menuTopics.scrollBy(150);
      })
      arrowRight.addEventListener('click', (e) => {
        menuTopics.scrollBy(-150);
      })

      // Show or hide the arrows based on the initial menu position
      this.showOrHideMenuTopicsArrowsBasedOnScrollPosition(menuTopics, arrowLeft, arrowRight);

      // Show or hide the arrows depending on the scrolling position
      menuTopics.on('scrollEnd', () => {
        this.showOrHideMenuTopicsArrowsBasedOnScrollPosition(menuTopics, arrowLeft, arrowRight);
      })
    }
  },

  /**
   * Remove any other submenu but the triggered one
   * This is the case if a submenu is open, but another one is then opened
   * We don't want two submenus opened at once
   *
   * @param triggeredMenuTopicItemWithSub
   */
  closeOtherTopicSubmenu: function (triggeredMenuTopicItemWithSub) {
    let menuTopicItemsWithSub = document.querySelectorAll('#menu-topics .has-sub');
    if (menuTopicItemsWithSub) {
      menuTopicItemsWithSub.forEach(menuTopicItemWithSub => {
        if (triggeredMenuTopicItemWithSub === menuTopicItemWithSub.querySelector('a:first-child')) {
          return;
        }
        let isSubExpanded = menuTopicItemWithSub.getAttribute('aria-expanded');
        if (isSubExpanded && isSubExpanded === 'true') {
          menuTopicItemWithSub.setAttribute('aria-expanded', 'false');
          document.querySelector('#menu-topics-popover-holder').innerHTML = '';
          window.AblCh.menuTopicsSub.destroy();
        }
      });
    }
  },

  showOrHideMenuTopicsArrowsBasedOnScrollPosition: function (betterScrollInstance, arrowLeft, arrowRight) {
    if (betterScrollInstance.x < betterScrollInstance.minScrollX) {
      arrowLeft.style.display = 'block';
    } else {
      arrowLeft.style.display = 'none';
    }
    if (betterScrollInstance.x > betterScrollInstance.maxScrollX) {
      arrowRight.style.display = 'block';
    } else {
      arrowRight.style.display = 'none';
    }
  },

  moveArticleMeta: function () {
    // move author and issue number data before lead, if present
    const articleMetaElements = document.querySelector('#content .article-meta-mobile');
    const leadElement = document.querySelector('#content p.magazine-lead');
    const backendMode = document.querySelector('body.neos-backend');
    if(leadElement != null && backendMode == null){
      leadElement.insertBefore(articleMetaElements, leadElement.firstChild)
    }
  }

})
